<label class="toggle-wrapper">
  @if (label) {
    <span class="toggle-label">{{ label }}</span>
  }
  <div class="toggle" [class.checked]="checked" (click)="onToggleChange()">
    <div class="knob"></div>
  </div>
</label>
